import React from "react";

function SearchButton() {
  return (
    <div>
      <button className="btn btn-primary">Search</button>
    </div>
  );
}
export default SearchButton;
